import type { ConsumerExtraService } from '../types/dtos';
import { useT } from '../hooks/useT';

type Props = {
  extras: ConsumerExtraService[];
  selected: string[];
  onChange: (next: string[]) => void;
};

export function ExtrasPicker({ extras, selected, onChange }: Props) {
  const { t } = useT();
  if (extras.length === 0) return null;

  const toggle = (id: string) => {
    onChange(selected.includes(id) ? selected.filter((s) => s !== id) : [...selected, id]);
  };

  return (
    <fieldset className="mt-6">
      <legend className="mb-2 text-base font-medium text-slate-900">{t('offer.optional_extras')}</legend>
      <div className="space-y-2">
        {extras.map((e) => (
          <label
            key={e.id}
            className="flex cursor-pointer items-start gap-3 rounded-lg border border-slate-300 bg-white p-3 hover:border-brand focus-within:ring-2 focus-within:ring-brand-ring"
          >
            <input
              type="checkbox"
              value={e.id}
              checked={selected.includes(e.id)}
              onChange={() => toggle(e.id)}
              className="mt-0.5 h-4 w-4 text-brand focus:ring-brand-ring"
            />
            <div className="flex-1">
              <div className="font-medium">{e.label}</div>
              {e.description && <div className="text-sm text-slate-600">{e.description}</div>}
            </div>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
